import React from 'react';
import { ActivityIndicator } from '@kontentino/ui';
import InstagramAudioTrackListItem from './InstagramAudioTrackListItem';
import type { InstagramAudioTrack } from '../../types';

interface InstagramAudioTrackListProps {
  tracks: InstagramAudioTrack[];
  selectedAudioId: string | null;
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  sentryRef: (node: HTMLElement | null) => void;
  onToggleSelect: (track: InstagramAudioTrack) => void;
}

const InstagramAudioTrackList = ({
  tracks,
  selectedAudioId,
  hasNextPage,
  isFetchingNextPage,
  sentryRef,
  onToggleSelect,
}: InstagramAudioTrackListProps) => (
  <div
    className="tw-flex tw-flex-col tw-gap-1 tw-py-1"
    data-name="instagram-audio_track-list"
  >
    {tracks.map((track) => (
      <InstagramAudioTrackListItem
        key={track.audio_id}
        track={track}
        isSelected={track.audio_id === selectedAudioId}
        onToggleSelect={onToggleSelect}
      />
    ))}

    {hasNextPage && (
      <div
        ref={sentryRef}
        className="tw-flex tw-justify-center tw-py-3"
        data-name="instagram-audio_track-list-sentinel"
      >
        {isFetchingNextPage && <ActivityIndicator />}
      </div>
    )}
  </div>
);

export default InstagramAudioTrackList;
